import _ from 'lodash';

import classnames from 'classnames';

export default (target, ...sources) => {
    // For some reason mergeWith mutates our target. Gotta clone it.
    const _target = _.cloneDeep(target);
    return _.mergeWith(
        _target,
        ...sources,
        (objValue, srcValue) => classnames(objValue, srcValue),
    );
};



// WEBPACK FOOTER //
// ./src/components/helpers/mergeStyles.js